import React from "react";
import Header from "../../Layout/Header";
import Footer from "../../Layout/Footer";

const Calendar = () => {
  return (
    <>
      <Header />
      <div className="container py-5">
        <iframe
          src="https://calendar.google.com/calendar/embed?src=73d49cd5d26e4f798fcf26ad1f5a5ea4af1fd5af82a99f378eff1928aee9c7f6%40group.calendar.google.com&ctz=America%2FChicago"
          style={{ border: "0", height: "100vh" }}
          width="800"
          height="h-100"
          frameborder="0"
          scrolling="no"
          title="calendar"
        ></iframe>
      </div>
      <Footer />
    </>
  );
};

export default Calendar;
